import { Injectable, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FeedbackArchiveStoreService } from './feedback-archive-store.service'
import { FeedbackArchiveApiService } from './feedback-archive-api.service'
import { SearchFeedbackRequestDTO } from '../../../apiModule'

@Injectable({ providedIn: 'root' })
export class FeedbackArchiveControllerService {
  private readonly store = inject(FeedbackArchiveStoreService)
  private readonly api = inject(FeedbackArchiveApiService)

  // Expose state as readonly signals
  readonly search = this.store.feedbackArchiveState.search
  readonly scroll = this.store.feedbackArchiveState.scroll
  readonly fullAttributes = this.store.feedbackArchiveState.fullAttributes
  readonly isLoading = this.store.feedbackArchiveState.isLoading
  readonly error = this.store.feedbackArchiveState.error

  // Request for attributes on initialization
  loadFullAttributes(): void {
    this.store.setLoading(true)
    this.api
      .getFullAttributes()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (attributes) => {
          this.store.updateFullAttributes(attributes)
          this.store.setLoading(false)
        },
        error: (err) => {
          this.store.setError('Failed to load attributes')
          this.store.setLoading(false)
        }
      })
  }

  // Update search filters
  updateSearch(search: SearchFeedbackRequestDTO): void {
    this.store.updateSearch(search)
  }

  // Update scroll position
  updateScroll(scroll: number): void {
    this.store.updateScroll(scroll)
  }

  // Reset state
  reset(): void {
    this.store.reset()
  }
}
